import { tokens } from "../tokens";

declare module '@mui/material/styles' {
  interface Palette {
    other: Palette['primary'];
  }

  interface PaletteOptions {
    other?: PaletteOptions['primary'];
  }
}
declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    other: true;
  }
}

const ThemeColors = () => {
  return {
    primary: {
      light: "#99d6a8",
      main: tokens.accent,
      dark: tokens.accentDark,
      contrastText: "#fff",
    },
    secondary: {
      light: "#2bb24c30",
      main: tokens.muted,
      dark: tokens.ink,
      contrastText: "#fff",
    },
    error: {
      main: tokens.danger,
    },
    other: {
      light: "#fafafa",
      main: "#F6F7F8",
      dark: "rgba(217,217,217,.65)",

    },
  };
};

export default ThemeColors;
